import { render, staticRenderFns } from "./SwellingTemplate.vue?vue&type=template&id=c60d7b6a"
import script from "./SwellingTemplate.vue?vue&type=script&lang=js"
export * from "./SwellingTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports